import { render } from "./AttachmentPopup.vue?vue&type=template&id=29c1c3ce"
import script from "./AttachmentPopup.vue?vue&type=script&lang=js"
export * from "./AttachmentPopup.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__